export const primaryColor = "#118AB2";
export const primaryDarkColor = "#1D1E2B";
export const white = "#FFFFFF";
export const primaryBtnColor = "#1a1a1a";
export const secondaryBlueColor = "#EFF7FA";
export const tertiary = "#E87841";
export const gray = "#99AEBB";
export const green = "#6DBAA2";
export const grayBG = "#f8f8f8";

//the tri color
export const black = "#000000";
export const contentBg = "#EFF0F3";
export const buttonColor = "#F0944F";

//
export const liberGrey = "#99AEBB";
export const panelBackground = "#F3F5FD";

/** Dashboard page shell (behind white cards). Slightly darker than #f4f4f4 so it still reads as grey on bright or poorly calibrated secondary monitors. */
export const dashboardShellBg = "#e8eaed";
